var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 17.9375L8.90919 12.9577C8.74559 12.35 8.66375 12.0462 8.50231 11.7978C8.35944 11.578 8.17203 11.3906 7.95219 11.2477C7.70384 11.0862 7.4 11.0044 6.79231 10.8408L1.8125 9.5L6.79231 8.15919C7.4 7.99559 7.70384 7.91375 7.95219 7.75231C8.17203 7.60944 8.35944 7.42203 8.50231 7.20219C8.66375 6.95384 8.74559 6.65 8.90919 6.04231L10.25 1.0625L11.5908 6.04231C11.7544 6.65 11.8362 6.95384 11.9977 7.20219C12.1406 7.42203 12.328 7.60944 12.5478 7.75231C12.7962 7.91375 13.1 7.99559 13.7077 8.15919L18.6875 9.5L13.7077 10.8408C13.1 11.0044 12.7962 11.0862 12.5478 11.2477C12.328 11.3906 12.1406 11.578 11.9977 11.7978C11.8362 12.0462 11.7544 12.35 11.5908 12.9577L10.25 17.9375Z",
    stroke: "url(#paint0_linear_22_324)",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_324",
    x1: 18.6875,
    y1: 17.9375,
    x2: -1.65923,
    y2: 10.2437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.158668,
    stopColor: "#F76A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60652,
    stopColor: "#A24AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.891362,
    stopColor: "#4859F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.dbea7c6effdce75bd9da166b10d1c216.svg";
export { ForwardRef as ReactComponent };